import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import mascotPopup from "./assets/mascot-popup.svg";

function AlertPopupMobile({ open, onClose, popupTitle, popupMessage }) {

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      disableScrollLock={true}
      PaperProps={{
        sx: {
          borderRadius: 4,
          py: 3,
          px: 0,
          display: "flex",
          justifyContent: "center",
          position: "relative",
          width: "420px",
          height: "230px",
          maxWidth: "90vw",
          mx: 2,
        },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: "grey.500",
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            px: 0,
            width: "100%",
          }}
        >
          {/* Top Row: Teddy and Text */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              mb: 3,
              pl: 0,
              pr: 2,
            }}
          >
            {/* Mascot Image */}
            <Box
              sx={{
                left: 0,
                ml: 0,
              }}
            >
              <Box
                component="img"
                src={mascotPopup}
                alt="Mascot Popup"
                sx={{
                  width: "50px",
                  height: "auto",
                }}
              />
            </Box>

            {/* Text Content */}
            <Box
              sx={{
                flex: 2,
                pl: 0,
                pt: 5,
                pr: 4,
                textAlign: "center",
                justifyContent:"center",
              //  maxWidth: "260px",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "#EF5658",
                  fontWeight: "bold",
                  fontSize: "11px",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  mb: 0.5,
                }}
              >
                {popupTitle}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: "#333",
                  fontSize: "14px",
                  pl: 0,
                  whiteSpace: "normal",
                  overflow: "hidden",
                }}
              >
                {popupMessage}
              </Typography>
            </Box>
          </Box>

          {/* Bottom: Centered Form */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              maxWidth: "280px",
            }}
          >
            <Button
              variant="contained"
              onClick={handleClose}
              fullWidth
              sx={{
                backgroundColor: "#EF5658",
                color: "white",
                borderRadius: "25px",
                fontSize: "14px",
                fontWeight: "bold",
                textTransform: "none",
                height: "45px",
                "&:hover": {
                  backgroundColor: "#d44749",
                },
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default AlertPopupMobile;
